import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAdminListParams } from '../shared/useAdminListParams';
import { AdminListToolbar } from '../shared/AdminListToolbar';
import { AddFeatureFlagTargetsDialog } from './AddFeatureFlagTargetsDialog';
import { getFeatureFlagFilters } from './FeatureFlagsTable/FeatureFlagFilters';
import { FeatureFlagsTable } from './FeatureFlagsTable';
import { AdminConfirmProvider } from '../shared/AdminConfirmProvider';
import { Box, Typography } from '@mui/material';

/**
 * Admin feature flags list: turn each flag on or off for everyone, and add or remove the
 * users, broker groups and ledgers it's also on for. The toolbar (search and filters), the
 * feature flags grid (FeatureFlagsTable), and the dialog that adds targets to a flag.
 */
export const FeatureFlagsListPage = () => {
	const { gridProps, search, setSearch, filters, setFilter, clearFilters } =
		useAdminListParams('featureFlags');

	return (
		<AdminConfirmProvider>
			<Box sx={{ p: 1, pb: 2, width: '100%' }}>
				<Typography>
					Enable/disable features for certain users, broker groups, etc. Every change
					re-renders the UI for that affected user.
				</Typography>
			</Box>

			<AdminListToolbar
				search={search}
				onSearchChange={setSearch}
				filters={getFeatureFlagFilters({ filters, setFilter })}
				onClearFilters={clearFilters}
			/>
			<FeatureFlagsTable search={search} filters={filters} gridProps={gridProps} />
			<AddFeatureFlagTargetsDialog />
			<Outlet />
		</AdminConfirmProvider>
	);
};
